// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1W6xA","rootSmall":"AddTileButton_rootSmall__3ZwIs"};